import { createStore, createEffect, createEvent } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { StatementsApi, type GenerateStatementOfFeesRequest } from '@shared/api';

const generateStatementOfFeesEffect = createEffect((request: GenerateStatementOfFeesRequest) => StatementsApi.generateStatementOfFees(request));
generateStatementOfFeesEffect.done.watch((result) => FileUtils.downloadFile(result.result));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateStatementOfFeesEffect.pending, (_, data) => data)
  .on(generateStatementOfFeesEffect.fail, () => false)
  .on(generateStatementOfFeesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(generateStatementOfFeesEffect, () => null)
  .on(generateStatementOfFeesEffect.fail, () => 'Something went wrong while generating Fee Statement. Please try again.')
  .on(generateStatementOfFeesEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $generateStatementOfFeesStore = {
  events: {
    generateStatementOfFees: generateStatementOfFeesEffect,
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
    error: $errorStore,
  },
};
